import type {L} from '../landcare-toolkit';


export function filterNodes(node: L.tree.Item | L.tree.Item[], f: (i: L.tree.Item) => boolean): L.tree.Item[] {
    let result = [];
    if (node instanceof Array) {
        for (let child of node) {
            result.push(...filterNodes(child, f));
        }
    } else {
        if (f(node)) {
            result.push(node);
        }

        if (node && node.children) {
            result.push(...filterNodes(node.children, f));
        }
    }
    return result;
}
